export default {
  primary: "#00778B",
  primaryLight: "#74B5C0",
  mutedBlue: "#7E8492",
  paleSkyBlue: "#727B8F",
  green: "#5CB85F",
  white: "#D1D4D9",
  black: "#4B5468",
}
